import React, { useState, useContext, useMemo, Fragment, useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import { useAliveController } from 'react-activation'
import { Dropdown, message } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons';
import MainContext from '@/stores/stores'
import { useIntl } from 'react-intl'
import styles from './index.module.scss'
import LogoImg from './LogoImg'
import accountApi from '@/api/accountApi';

const HeaderOne: React.FC<any> = (props) => {
  const token = localStorage.getItem("token") || ''
  const { headerInfo={} } = props
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  let params = searchParams.get("params")
  const intl = useIntl()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, isWomala, host, colorPrimary, fontColorPrimary, canLang, isCst, distributorInfo, hasFreeVin, sxSetData  } = commonStore

  let domain = window.location.host

  const [longer, setLonger] = useState<boolean>(true)
  const [allNav, setAllNav] = useState<any[]>([])
  const [standardNav, setStandardNav] = useState<any[]>([])
  const [moreNav, setMoreNav] = useState<any[]>([])

  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    getNavgation()
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
  }, [])

  useEffect(() => {
    const lang: any  = window.localStorage.getItem('lang')
    if(lang === 'zh' || lang === 'cht') {
      if(document.body.clientWidth <= 1420) {
        setLonger(false)
      }else if(document.body.clientWidth <= 1800) {
        if((standardNav.length + moreNav.length) <= 8) {
          setLonger(true)
        }else {
          setLonger(false)
        }
      }else {
        setLonger(true)
      }
    }else {
      if(document.body.clientWidth <= 1800) {
        setLonger(false)
      }else if(document.body.clientWidth <= 2400) {
        if((standardNav.length + moreNav.length) <= 10) {
          setLonger(true)
        }else {
          setLonger(false)
        }
      }else {
        setLonger(true)
      }
    }
    if((standardNav.length + moreNav.length) <= 6) {
      setLonger(true)
    }
    
  },[standardNav, moreNav])

  const getNavgation = () => {
    accountApi.getNavgationNew({ domain: host || domain }).then((res: any) => {
      if(res.code === 1) {
        let navData = res.data
        let _allNav: any[] = []
        let cjhIndex = navData.findIndex((ele: any) => ele.path === '/cjh')
        let cjhItem = cjhIndex > -1 ? navData[cjhIndex] : {}
        let oeIndex = navData.findIndex((ele: any) => ele.path === '/oe')
        let oeItem = oeIndex > -1 ? navData[oeIndex] : {}
        navData.forEach((ele: any) => {
          if((ele.path === '/vin' || ele.path === '/cjh' || ele.path === '/carsearch') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/cjh')
            if(index === -1) {
              _allNav.push({
                path: '/cjh',
                is_add: 0,
                is_check: 1,
                name: cjhItem.name ? cjhItem.name : intl.formatMessage({id: '车架号查询'}),
                icon: ''
              })
            }
          }else if((ele.path === '/code' || ele.path === '/oe') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/oe')
            if(index === -1) {
              _allNav.push({
                path: '/oe',
                is_add: 0,
                is_check: 1,
                name: oeItem.name ? oeItem.name : intl.formatMessage({id: '零件号查询'}),
                icon: 'icon-lingjianchaxun'
              })
            }
          }else if(ele.is_add && ele.is_check) {
            ele.path = `/morepage/${ele.code}`
            _allNav.push(ele)
          }else if(ele.is_check) {
            if(ele.path === '/epc') {
              ele.icon = 'icon-EPCchaxun'
            }else if(ele.path === '/enquery') {
              ele.icon = 'icon-fabuxunjia'
            }
            _allNav.push(ele)
          }
        })
        let _standardNav = _allNav.filter((item: any, index: number) => index === 0 || (!item.is_add && item.is_check && item.path !== '/engine'))
        let _moreNav = _allNav.filter((item: any, index: number) => {
          if(item.is_add && item.is_check && index !== 0) {
            item.path = `/morepage/${item.code}`
            return true
          }
        })
        let filterStdNav = _standardNav
        if(filterStdNav.length < 4) {
          let lastIndexLen = 4 - filterStdNav.length
          let otherStandardNav = _moreNav.slice(0, lastIndexLen)
          _standardNav = [..._standardNav, ...otherStandardNav]
          _moreNav = _moreNav.slice(lastIndexLen)
        }
        let _homeUrl = _allNav[0] && _allNav[0].path ? _allNav[0].path : ''
        // console.log("homeUrl:", _homeUrl)
        setCommonStore({
          type: 'homeUrl',
          value: _homeUrl
        })
        setAllNav(_allNav)
        setStandardNav(_standardNav)
        setMoreNav(_moreNav)
      }
    })
  }

  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }

  const setLang = (lang: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra") => {
    setSearchParams({})
    window.localStorage.setItem('lang', lang)
    window.location.href = "/home"
  }

  const langItems: any = [
    {
      key: 'zh',
      label: (
        <div className="flex-s-c" onClick={() => setLang('zh')}>
          中文
        </div>
      )
    },
    {
      key: 'en',
      label: (
        <div className="flex-s-c" onClick={() => setLang('en')}>
          English
        </div>
      )
    },
    {
      key: 'ru',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ru')}>
          Русский язык
        </div>
      )
    },
    {
      key: 'fra',
      label: (
        <div className="flex-s-c" onClick={() => setLang('fra')}>
          French
        </div>
      )
    },
    {
      key: 'cht',
      label: (
        <div className="flex-s-c" onClick={() => setLang('cht')}>
        中文-繁體
        </div>
      )
    },
    {
      key: 'tr',
      label: (
        <div className="flex-s-c" onClick={() => setLang('tr')}>
        Türkiye
        </div>
      )
    },
    {
      key: 'ara',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ara')}>
          بالعربية
        </div>
      )
    },
    {
      key: 'pt',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pt')}>
          Português
        </div>
      )
    },
    {
      key: 'vie',
      label: (
        <div className="flex-s-c" onClick={() => setLang('vie')}>
          Tiếng Việt
        </div>
      )
    },
    /* {
      key: 'may',
      label: (
        <div className="flex-s-c" onClick={() => setLang('may')}>
          Bahasa Melayu
        </div>
      )
    },
    {
      key: 'th',
      label: (
        <div className="flex-s-c" onClick={() => setLang('th')}>
          ภาษาไทย
        </div>
      )
    },
    {
      key: 'id',
      label: (
        <div className="flex-s-c" onClick={() => setLang('id')}>
          Bahasa Indonesia
        </div>
      )
    },
    {
      key: 'pl',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pl')}>
          Polski
        </div>
      )
    } */
  ].filter((item: any) => canLang && canLang.includes(item.key))

  const lang: any  = window.localStorage.getItem('lang')

  const toHome = () => {
    navigate('/home')
  }

  const toGo = (url: string) => {
    navigate(url)
  }

  const checkUrl = () => {
    if(token && (!localStorage.getItem('tourist_user'))) {
      if(commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1) {
        toGo('/mine/order')
      }else {
        toGo('/mine/setting')
      }
      
    }else {
      toGo('/login')
    }
  }

  const openNew = () => {
		window.open("/merchant/order/list", "__blank")
	}

  const toMobilePage = () => {
    localStorage.removeItem('preferDesktop')
    window.location.href = origin.includes('localhost') ? 'http://localhost:3000/#/' : origin + '/h5_index.html#/'
  }

  const goMore = (item: any) => {
    navigate(item.path)
  }

  const goToUrl = (item: any) => {
    let is_must = item.is_must
    
    let url = item.path
    
    if(url) {
      try {
        clear()
      }catch(err: any) {
        
      }
      setTimeout(() => {
        if(window.location.host.includes("partsbond") && url === '/epc') {
          if(window.localStorage.getItem("lang") === 'ru') {
            window.open('https://ru.partsbond.com',"__blank")
          }else {
            window.open('https://partsbond.com',"__blank")
          }
        }else {
          if(url === '/enquery' || url.includes('/epc')) {
            if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
              navigate(url)
            }else {
              message.warning(intl.formatMessage({ id: "请先登录" }))
              toGo('/login')
            }
          }else {
            navigate(url)
          }
        }
      },100)
      return false
    }
  }

  const showMore = useMemo<any>(() => {
    if(isWomala || moreNav.length) {
      return [
        {
          name: intl.formatMessage({ id: '更多' }),
          key: 'more'
        }
      ]
    }else {
      return []
    }
  },[moreNav])

  const moreArr: any = isWomala ? [
    {
      name: intl.formatMessage({ id: '关于我们' }),
      path: '/aboutus',
      code: 'about_us',
      icon: 'icon-guanyuwomen'
    },
    {
      name: intl.formatMessage({ id: '联系我们' }),
      path: '/contactus',
      code: 'contract_us',
      icon: 'icon-lianxiwomen'
    },
    {
      name: intl.formatMessage({ id: '疑问解答' }),
      path: '/doubt',
      code: 'faq',
      icon: 'icon-yiwenjieda'
    },
    {
      name: intl.formatMessage({ id: '购买流程' }),
      path: '/buypath',
      code: 'purchase_process',
      icon: ''
    },
  ]: moreNav
  
  const linkArr = [
    ...standardNav,
    ...showMore
  ]
  const _linkArr = longer ? [
    ...allNav
  ] : linkArr

  return (
    <div className={styles['header']} style={{ height: 150 }}>
      <>
        <div className={styles['header-t']} style={{ backgroundColor: '#fff', color: '#333', height: '105px'}}>
          {
            token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <LogoImg style={{height: headerInfo.logo_height}} src={headerInfo.logo || ""}/> : <img src={headerInfo.logo || ""} alt="" style={{height: headerInfo.logo_height }} onClick={toHome} />
          }
          <div className={styles['tr']}>
            <div className="flex-s-c" style={{ flexDirection: 'row-reverse' }}>
              {
                token && (!localStorage.getItem('tourist_user')) ? (
                  <div className="flex-s-c pointer"  onClick={() => toGo('/cart')}>
                    <i className="iconfont icon-a-gouwucheman2 mr5"/>
                    {intl.formatMessage({ id: '购物车' })}({commonStore.cartNum})
                  </div>
                ): null
              }
              <div className="flex-s-c mr30 pointer"  onClick={() => checkUrl() }>
                <i className="iconfont icon-a-wo1 mr5"/>
                {
                  token && (!localStorage.getItem('tourist_user')) ? (
                    <>
                      {userInfo.wechat_nick || userInfo.phone}
                    </>
                  ): <>{intl.formatMessage({ id: '请登录' })}</>
                }
                <i className="iconfont icon-down ml5" />
              </div>
              <div className="flex-s-c" >
                <Dropdown menu={{ items: langItems }}>
                  <div className={styles['lang'] + ' flex-s-c mr30 pointer'} style={{ color: '#333333' }}>
                    {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                    { lang === 'zh' ? '中文' 
                    : lang === 'en' ? 'English' 
                    : lang === 'ru' ? 'Русский язык' 
                    : lang === 'cht' ? '中文-繁體' 
                    : lang === 'tr' ? 'Türkiye' 
                    : lang === 'ara' ? 'بالعربية' 
                    : lang === 'pt' ? 'Português'
                    : lang === 'vie' ? 'Tiếng Việt'
                    : lang === 'fra' ? 'French' : '中文' }
                  </div>
                </Dropdown>
              </div>
              {
                distributorInfo.status ? (
                  <div className='flex-s-c'>
                    <div onClick={() => navigate("/mine/invitation")} className={styles['invitation-code'] + ' flex-s-c mr20 pointer'}>
                      <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                      {intl.formatMessage({ id: '邀请码' })}
                    </div>
                    {
                      userInfo.is_repair_shop_admin ? (
                        <div className={'pointer flex-s-c mr20'} onClick={() => openNew()}>
                          <i className="iconfont icon-a-Group21471 mr10"/>
                          {intl.formatMessage({ id: '商户后台' })}
                        </div>
                      ): null
                    }
                  </div>
                ): null
              }
              {
                isMobile ? <div className="flex-s-c mr30 pointer" onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
              }
            </div>
          </div>
        </div>
        <div className={styles['header-b']} style={{ backgroundColor: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#FFFFFF' }}>
          <div className={styles['links']}>
            {
              _linkArr.map((link: any, index: any) => {
                if(link.key) {
                  let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                  
                  return (
                    <Fragment key={index}>
                      <Dropdown menu={{ 
                        items: moreArr.map((item: any) => {
                          return {
                            key: item.path,
                            label: <div onClick={() => goMore(item)}>{item.name}</div>
                          }
                        }) 
                      }}
                      >
                        <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '' }`} key={index} style={{borderRight: '1px solid #8E8E8E', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? '500' : '400'}}>
                          {nowItem ? nowItem.name : link.name}
                          <CaretDownOutlined className="ml5" />
                        </div>
                      </Dropdown>
                    </Fragment>
                    
                  )
                }
                return (
                  <Fragment key={index}>
                    <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: '1px solid #8E8E8E', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                      {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : null}{link.name}
                      
                    </div>
                  </Fragment>
                )
              })
            }
          </div>
        </div>
      </>
    </div> 
  )
}

export default HeaderOne